
import React from "react";
import { Button } from "@/components/ui/button";
import { CheckCircle, XCircle, ArrowRight, AlertTriangle } from "lucide-react";

interface PendingApplicationActionsProps {
  applicationId: string;
  onStatusUpdate: (applicationId: string, status: 'approved' | 'rejected') => void;
  loading: boolean;
}

export default function PendingApplicationActions({ 
  applicationId, 
  onStatusUpdate, 
  loading 
}: PendingApplicationActionsProps) {
  return (
    <div className="space-y-2">
      <h4 className="font-medium text-sm">Available Actions</h4>
      
      <Button
        onClick={() => onStatusUpdate(applicationId, 'approved')}
        className="w-full justify-between bg-green-600 hover:bg-green-700"
        disabled={loading}
      >
        <span className="flex items-center gap-2">
          <CheckCircle className="h-4 w-4" />
          Approve Application
        </span>
        <ArrowRight className="h-4 w-4" />
      </Button>
      
      <Button
        onClick={() => onStatusUpdate(applicationId, 'rejected')}
        variant="destructive"
        className="w-full justify-between"
        disabled={loading}
      >
        <span className="flex items-center gap-2">
          <XCircle className="h-4 w-4" />
          Reject Application
        </span>
        <AlertTriangle className="h-4 w-4" />
      </Button>
    </div>
  );
}
